import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '../routes/routes';

interface IHomepageProps {}

export const Homepage: React.FunctionComponent<IHomepageProps> = () => {
    return <Navigate to={ROUTES.activity.search} replace />;
};
